import { apiClient } from '../../gateways/api'

export { copyAanvraag }

const copyAanvraag = async ({
  aanvraagID,
  data: {
    newAanvraagID,
    aanvraagDatum,
    wensWeek,
    wensJaar,
    agd,
    wachtTijdDatum,
    agdRelevant,
    grootverbruikDisciplineIDs,
  },
}: {
  aanvraagID: string
  data: {
    newAanvraagID: string
    aanvraagDatum: string
    wensWeek: string
    wensJaar: string
    agd: string
    wachtTijdDatum: string
    agdRelevant: boolean
    grootverbruikDisciplineIDs: string
  }
}) => {
  await apiClient({
    url: `/rest/beheer/aanvraag/${aanvraagID}/copy`,
    method: 'POST',
    data: {
      newAanvraagID,
      aanvraagDatum,
      wensWeek,
      wensJaar,
      agd,
      wachtTijdDatum,
      agdRelevant,
      grootverbruikDisciplineIDs,
    },
  })
}
